export default __webpack_public_path__ + "4ab13683ace960b00506df0f175365cd.svg";